import styled from 'styled-components';
import { ContentContainer } from '@riac/design-system';

export const CommentSection = styled(ContentContainer)`
  flex-flow: column nowrap;
  align-items: stretch;
  margin-bottom: 100px;
  max-width: 1000px;
`;

export const Title = styled.h2`
  text-align: center;
  width: 100%;
`;
